document.addEventListener('DOMContentLoaded', function () {
  const panels = document.querySelectorAll('.checkout-panel');

  panels.forEach(function (panel) {
    // panel.classList.add('loadable');
    // const forms = panel.querySelectorAll('form');
    // forms.forEach(function (form) {
    //   form.addEventListener('submit', function (e) {
    //     if (form.classList.contains('is-valid')) {
    //       panel.classList.add('loadable');
    //       panel.classList.add('is-loading');
    //       panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    //   });
    // });
    // const links = panel.querySelectorAll('a');
    // links.forEach(function (link) {
    //   link.addEventListener('click', function (e) {
    //     if (link.getAttribute('target') !== '_blank') {
    //       panel.classList.add('loadable');
    //       panel.classList.add('is-loading');
    //       panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    //   });
    // });
  });
});
